import type { StatutEtape } from '@/shared/donnees/types';

/**
 * Les couleurs de la chaîne d'étapes, les mêmes partout (frise de la fiche,
 * barres des listes) :
 * - vert : validée ;
 * - orange : envoyée au bureau, en attente de validation ;
 * - rouge : refusée, à reprendre ;
 * - bleu léger : planifiée (datée, démarrée ou non : la même chose) ;
 * - gris : pas encore planifiée.
 */
export type EtatChaine = 'validee' | 'a-valider' | 'refusee' | 'commencee' | 'a-faire';

export function etatChaine(statut: StatutEtape): EtatChaine {
  switch (statut) {
    case 'validee':
      return 'validee';
    case 'a-valider':
      return 'a-valider';
    case 'rouverte':
      return 'refusee';
    case 'en-cours':
    case 'planifiee':
      return 'commencee';
    case 'a-planifier':
      return 'a-faire';
  }
}

export const LIBELLE_ETAT_CHAINE: Record<EtatChaine, string> = {
  validee: 'Validée',
  'a-valider': 'En attente de validation',
  refusee: 'Refusée, à reprendre',
  commencee: 'Planifiée',
  'a-faire': 'Pas encore planifiée',
};

/** La couleur pleine de chaque état (fond d'une pastille, d'un segment). */
export const FOND_ETAT_CHAINE: Record<EtatChaine, string> = {
  validee: 'bg-chaine-validee',
  'a-valider': 'bg-chaine-a-valider',
  refusee: 'bg-chaine-refusee',
  commencee: 'bg-chaine-commencee',
  'a-faire': 'bg-chaine-a-faire',
};

export const ORDRE_ETATS_CHAINE: readonly EtatChaine[] = [
  'validee',
  'a-valider',
  'refusee',
  'commencee',
  'a-faire',
];
